import { Component, Inject, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ConfigurarPastaServiceService } from "app/configurar-pasta-service.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { DialogConfirmComponent } from "../../dialog-confirm/dialog-confirm.component";
import { MatDialog } from "@angular/material/dialog";
import { CriarAspectosComponent } from "../../../../vincular-tipo-cliente/criar-aspectos/criar-aspectos.component";
import { v4 as uuidv4 } from "uuid";

@Component({
  selector: "app-save-propertie-dialog",
  templateUrl: "./save-propertie-dialog.component.html",
  styleUrls: ["./save-propertie-dialog.component.scss"],
})
export class SavePropertieDialogComponent implements OnInit {
  public clienteId: number;
  public tipoId: number;
  public propForm: FormGroup;
  public tipoTitle: String;
  public nameTipo: String;
  public idAspectoSaved;
  public submit = false;
  public nomeFormatado;
  isLoading = false;
  types: any[] = [
    { value: "d:text", inputType: "text" },
    { value: "d:mltext", inputType: "text" },
    { value: "d:int", inputType: "number" },
    { value: "d:long", inputType: "number" },
    { value: "d:float", inputType: "number" },
    { value: "d:double", inputType: "number" },
    { value: "d:date", inputType: "date" },
    { value: "d:datetime", inputType: "date" },
    { value: "d:boolean", inputType: "boolean" },
  ];
  listItems = [];
  typeData = "text";

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,
    private configPastaService: ConfigurarPastaServiceService
  ) {
    this.route.params.subscribe(
      (params) => (this.clienteId = params["clienteId"])
    );
    this.route.params.subscribe((params) => (this.tipoId = params["tipoId"]));
    this.idAspectoSaved = this.tipoId;
  }

  ngOnInit() {
    this.getNomeTipo(this.tipoId);
    this.propForm = this.fb.group({
      name: [{ value: "", disabled: true }, Validators.required],
      title: ["", Validators.required],
      description: [""],
      type: ["", Validators.required],
      mandatory: ["", Validators.required],
      defaultValue: [""],
      constraint: [""],
      newProperty: [true],
    });
    console.log(uuidv4());
  }

  onChangeTypeData(typeSelected) {
    const obj = this.types.find((e) => e.value === typeSelected);
    this.typeData = obj.inputType;
  }

  getNomeTipo(id) {
    this.configPastaService.getNomeTipo(id).subscribe(
      (data) => {
        console.log(data);
        const fullName = data.name;
        const splitFullName = fullName.split(":");
        const prefix = splitFullName[0];
        this.nameTipo = prefix;
        this.tipoTitle = data.title;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  onChangeConstraint(constraint) {
    // console.log(constraint);
    if (constraint === "LIST") {
      this.propForm.get("constraint").setValue("LIST");
      this.propForm.removeControl("regex");
      this.propForm.addControl(
        "list",
        this.fb.array([])
        // new FormControl(this.listItems, Validators.required)
      );
    } else if (constraint === "REGEX") {
      this.propForm.get("constraint").setValue("REGEX");
      this.propForm.removeControl("list");
      this.listItems = [];
      this.propForm.addControl(
        "regex",
        new FormControl("", Validators.required)
      );
    } else {
      this.propForm.get("constraint").setValue(null);
      this.propForm.removeControl("list");
      this.listItems = [];
      this.propForm.removeControl("regex");
    }
  }

  get list() {
    return this.propForm.get("list") as FormArray;
  }

  addItemList() {
    this.list.push(this.fb.control(""));
  }

  addInput() {
    this.listItems.push({ id: null, value: null });
    this.propForm.get("list").setValue(this.listItems);
  }

  insertInList(value, position) {
    console.log(value);
    console.log(position);
    this.listItems[position].value = value;
    console.log(this.listItems);
  }

  delItem(index, item) {
    console.log(index);
    console.log(item);
    this.listItems.splice(index, 1);
  }

  deleteItem(index) {
    if (index > 0) {
      this.list.removeAt(index);
      //this.list.controls[this.list.length] = new FormControl('');
      //this.list.removeAt(this.list.length - 1);
    } else {
      this.openSnackBar("O primeiro item da lista é obrigatório !", true);
    }
  }

  // ngOnDestroy() {
  //   if (this.data.prop.constraint && this.data.prop.constraint.listaItens) {
  //     this.listItems = [...this.data.prop.constraint.listaItens];
  //   }
  // }

  keyFunc(e) {
    this.formatarNome(e.target.value);
  }

  focusOutFunc(e) {
    if (e) {
      const nome = this.propForm.get("name").value;
      this.buscarPropertyByName(nome);
    }
  }

  buscarPropertyByName(nome: String) {
    this.configPastaService.buscarPropertyByName(nome).subscribe(
      async (data) => {
        console.log(await data);
        if (data.existe && !data.is_aspect) {
          console.log(data.propriedade);
          this.confirmCreateAspect(this.tipoId, data.propriedade.id);
        } else if (data.existe && data.is_aspect) {
          console.log(data.propriedade);
          this.confirmVincularAspect(
            this.tipoId,
            data.propriedade.id,
            data.node_dicionario
          );
        } else {
          console.warn("Nova propriedade");
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  confirmVincularAspect(tipoId: number, propId: number, aspecto) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Uma propriedade com esse nome já foi criada e vinculada a um aspecto ! Deseja vincular o aspecto a este tipo ?",
        from: "save-propertie-dialog.component.ts_vincular",
        aspecto: aspecto,
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: any) => {
      console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.setPropInAspect(aspecto.id, tipoId);
        // alert(`Id do tipo = ${tipoId} | Id da propriedade = ${propId} | Escolheu criar o aspecto`);
      } else {
        this.idAspectoSaved = Number(tipoId);
      }
    });
  }

  confirmCreateAspect(tipoId: number, propId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Uma propriedade com esse nome já foi criada ! Deseja criar um aspecto para esta propriedade ?",
        from: "save-propertie-dialog.component.ts",
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: any) => {
      console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.openCriarAspecto(tipoId, propId);
        // alert(`Id do tipo = ${tipoId} | Id da propriedade = ${propId} | Escolheu criar o aspecto`);
      } else {
        this.idAspectoSaved = Number(tipoId);
      }
    });
  }

  openCriarAspecto(tipoId, propId) {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth / 2 + "px";
    }

    const dialogRef = this.dialog.open(CriarAspectosComponent, {
      data: {
        tipoId: tipoId,
        propExistId: propId,
      },
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data !== null) {
        this.idAspectoSaved = data;
        this.setPropInAspectAndAspectInType(Number(tipoId), propId, data);
      }
    });
  }

  setPropInAspectAndAspectInType(tipoId, propId, aspectId) {
    const body = {
      tipoId: tipoId,
      propId: propId,
      aspectoId: aspectId,
    };
    this.configPastaService.setPropInAspectAndAspectInType(body).subscribe(
      (data) => {
        console.log(data);
        this.openSnackBar("Aspecto criado e vinculado !", false);
        this.router.navigate(["/configurar-tipo-cliente/", this.clienteId]);
      },
      (error) => {
        this.openSnackBar("Erro !", true);
        console.error(error);
      }
    );
  }

  setPropInAspect(idAspect, idNode) {
    this.configPastaService.setPropInAspect(idAspect, idNode).subscribe(
      (data) => {
        console.log(data);
        this.openSnackBar("Aspecto vinculado a este tipo !", false);
        this.router.navigate(["/configurar-tipo-cliente/", this.clienteId]);
      },
      (error) => {
        this.openSnackBar("Erro !", true);
        console.error(error);
      }
    );
  }

  createAspect(condicional: boolean) {
    if (condicional) {
      alert("Ok, vamos ciar o aspecto");
    }
  }

  // formatarNome(nome) {
  //   const re = /(do\s|da\s|do\s|das\s|de\s|di\s|du\s|Do\s|Da\s|Do\s|Das\s|De\s|Di\s|Du\s|DO\s|DA\s|DO\s|DAS\s|DE\s|DI\s|DU )/;
  //   const str = nome;
  //   const newstr = str.replace(' ', '');
  //   const newstr2 = newstr.replace(re, '');
  //   const stringFormatada = newstr2.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  //   const er = /[^a-z0-9]/gi;
  //   const withoutCaractherSpecial = stringFormatada.replace(er, '');
  //   this.propForm.get('name').setValue(withoutCaractherSpecial);
  // }

  formatarNome(nome) {
    const str = nome;
    const wordsIgnored = [
      " da ",
      " das ",
      " DAS ",
      " DA ",
      " DO ",
      " DE ",
      " DOS ",
      " de ",
      " do ",
      " dos ",
      " Da ",
      " Das ",
      " De ",
      " Do ",
      " Dos ",
      " ",
    ];
    const re = new RegExp("\\b(" + wordsIgnored.join("|") + ")\\b", "g");
    const nameFormated = str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()@¨+]/g, "")
      .replace(re, "")
      .replace(/[ ]{2,}/, " ");
    this.nomeFormatado = nameFormated;
    const nomeFormat = `${this.nameTipo}:${nameFormated}`;
    this.propForm.get("name").setValue(nomeFormat);
  }

  saveData() {
    console.log(this.propForm.value);
    this.submit = true;
    if (this.propForm.valid) {
      const constraintNula: any = {
        expression: "",
        listaItens: "",
        type: "",
      };
      this.isLoading = true;
      // console.log(this.listItems);
      // console.log(this.propForm);

      const propToSave: any = {
        defaultValue: this.propForm.get("defaultValue").value,
        mandatory: this.propForm.get("mandatory").value,
        name: this.propForm.get("name").value,
        title: this.propForm.get("title").value,
        type: this.propForm.get("type").value,
        newProperty: this.propForm.get("newProperty").value,
        description: this.propForm.get("description").value,
      };

      switch (this.propForm.get("constraint").value) {
        case "none":
          propToSave.constraint = null;
          break;
        case "LIST":
          propToSave.constraint = { ...constraintNula };
          propToSave.constraint.name = `${this.nameTipo}:LIST_${uuidv4()}`;
          propToSave.constraint.expression = null;
          const listaItems = [];
          const lista: any[] = this.propForm.value.list;
          lista.forEach((el) => {
            listaItems.push({ id: null, value: el });
          });
          propToSave.constraint.listaItens = listaItems;
          propToSave.constraint.type = "LIST";
          break;
        case "REGEX":
          propToSave.constraint = { ...constraintNula };
          propToSave.constraint.name = `${this.nameTipo}:REGEX_${uuidv4()}`;
          propToSave.constraint.expression = this.propForm.get("regex").value;
          propToSave.constraint.listaItens = null;
          propToSave.constraint.type = "REGEX";
          break;
      }

      console.log(propToSave);

      this.configPastaService
        .saveProperty(propToSave, this.idAspectoSaved)
        .subscribe(
          async (data) => {
            console.log(data);
            this.isLoading = false;
            await this.openSnackBar(
              "propriedade adicionada com sucesso!",
              false
            );
            await this.router.navigate([
              `edit-properties/${
                this.clienteId
                  ? this.clienteId + "/" + this.tipoId
                  : this.tipoId
              }`,
            ]);
          },
          (err) => {
            console.error(err);
            this.openSnackBar(
              "Ocorreu um erro ao adicionar propriedade, tente novamente em alguns instantes",
              true
            );
            this.isLoading = false;
          }
        );
    } else {
      this.openSnackBar("Preencha todos os campos obrigatórios !", true);
    }
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, "", {
      horizontalPosition: "right",
      verticalPosition: "top",
      duration: 3000,
      panelClass: isErr ? ["error-snackbar"] : ["success-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/dialog/edit-propertie-dialog/save-propertie-dialog/save-propertie-dialog.component.ts